import { render } from "./BlogHeader.vue?vue&type=template&id=8e1f1fc4&scoped=true"
import script from "./BlogHeader.vue?vue&type=script&lang=js"
export * from "./BlogHeader.vue?vue&type=script&lang=js"

import "./BlogHeader.vue?vue&type=style&index=0&id=8e1f1fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1f1fc4"]])

export default __exports__